export const PROJECTS = [
  {
    name: "CAN",
    id: 1,
    sponsor: "NIH",
    active: false,
    project_start_date: "10/1/2008",
    project_end_date: "9/31/2014"
  },
  {
    name: "CLN",
    id: 2,
    sponsor: "NIEHS",
    active: true,
    project_start_date: "10/1/2007",
    project_end_date: "10/1/2022"
  },
  {
    name: "AMI",
    id: 3,
    sponsor: "NSF",
    active: true,
    project_start_date: "10/1/2007",
    project_end_date: "10/1/2027"
  }
];